import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagTwoToneSvg from "@ant-design/icons-svg/es/asn/TagTwoTone";
import AntdIcon from '../components/AntdIcon';
var TagTwoTone = function TagTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: TagTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(TagTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'TagTwoTone';
}
export default RefIcon;